import {useLocation, useNavigate} from "react-router-dom";
import {useEffect, useState} from "react";
import {divarLinkGenerator, safeRedirect} from "../../tools/helpers";
import Api from "../../tools/service";
import {Reoverlay} from "reoverlay";
import ErrorModal from "../../components/modals/ErrorModal";
import {ForeignerAuthenticationDefaultSteps} from "../../tools/defaults/authentication/ForeignerAuth";
import ForeignerAuthenticationContext from "../../tools/contexts/authenticatonService/ForeignerAuthenticationContext";
import {StreamManager} from "../../tools/contexts/StreamManager";
import VideoValidation from "../../components/foreignerAuth/VideoValidation";
import Final from "../../components/foreignerAuth/Final";
import LoadingScreen from "../../components/LoadingScreen";
import UserReportedCard from "../../components/foreignerAuth/UserReportedCard";
import CardReader from "../../components/foreignerAuth/CardReader";
import REQUEST_URLS from "../../tools/defaults/requestUrl";
import useDivarAuth from "../../hooks/useDivarAuth";


const ForeignerAuth = () => {
    const {ticketUuid,serviceType,token,returnUrl}=useDivarAuth();
    const [pid, setPid] = useState(null);
    const [isLoading, setIsLoading] = useState({
        showLoading: false,
        text: 'لطفا منتظر بمانید'
    });
    const [process, setProcess] = useState(null);
    const [components, setComponents] = useState(null);
    const [reported, setReported] = useState(false);
    const [reportedMessage, setReportedMessage] = useState('');
    const [reportedTitle, setReportedTitle] = useState('');
    const [isFinal, setIsFinal] = useState(false)
    const navigate = useNavigate();
    useEffect(() => {
        handleInquiryProcess();

    }, []);
    const handleRedirectToDivar = ({price, status}) => {
        const link = divarLinkGenerator({
            returnUrl,
            price,
            status,

        },true);
        safeRedirect(link, () => {

            setTimeout(() => {
                Reoverlay.showModal(ErrorModal, {
                    showConfirmButton: true,
                    confirmButtonText: 'بستن',
                    confirmButtonTheme: 'red',
                    title: 'خطا',
                    message: 'لینک معتبر نمی باشد.',
                    onConfirm: () => {
                        Reoverlay.hideModal()
                        navigate('/404')
                    }
                })
            }, 100)
        })
    }
    const handleProcess = (newProcess) => {
        setProcess(newProcess)
    }
    const handleLoading = (newLoading) => {
        setIsLoading(newLoading)
    }

    const handleUpdateStep = (newStep, passedStep) => {
        if (passedStep) {
            let passedSteps = [...process.passed_steps, passedStep];

            const newState = {
                ...process,
                current_step: newStep,
                passed_steps: passedSteps,
            }

            setProcess(newState)
        } else {
            const newState = {
                ...process,
                current_step: newStep
            }

            setProcess(newState)
        }
    };
    const handleCreateProcess = () => {
        setIsLoading({
            showLoading: true,
            text: 'در حال ساخت فرایند'
        })
        Api.post(REQUEST_URLS.DIVAR_FOREIGNER_AUTH.CREATE_PROCESS, {
            "post_token": ticketUuid
        }, {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        }).then(response => {
            const {data, status, message, hasError} = response;

            if (hasError) {
                setIsLoading({
                    showLoading: true,
                    text: 'در حال ساخت فرایند'
                })
                handleError({
                    data, status, message, callback: () => {
                        Reoverlay.showModal(ErrorModal, {
                            title: 'خطا',
                            message: message || 'خطای سرویس',
                            showConfirmButton: false,
                            showCancelButton: true,
                            cancelButtonText: status === 845 ? 'بازگشت به دیوار' : 'تلاش مجدد',
                            cancelButtonTheme: status === 845 ? "light" : 'red',
                            onCancel: () => {
                                if (status === 845) {
                                    handleRedirectToDivar({status: 'fail', price: 0})
                                } else {
                                    handleCreateProcess();
                                }

                            }
                        })
                    }
                })
            } else {
                setIsLoading({
                    showLoading: false,
                    text: 'در حال دریافت اطلاعات'
                })
                setPid(data.pid);
                handleGetProcess(data.pid)
            }
        }).catch(e => {
            console.log(e)
        }).finally(() => {

        })
    }
    const handleInquiryProcess = () => {
        setIsLoading({
            showLoading: true,
            text: 'در حال دریافت اطلاعات'
        });
        Api.get(REQUEST_URLS.DIVAR_FOREIGNER_AUTH.INQUIRY_PROCESS, {
            params: {
                post_token: ticketUuid,
                service_type: serviceType,
            },
            headers: {
                "Authorization": `Bearer ${token}`
            }
        }).then(response => {
            const {status, data, message, hasError} = response;
            if (hasError) {
                setIsLoading({
                    showLoading: false,
                    text: 'در حال دریافت اطلاعات'
                })

                handleError({
                    status,
                    message: status === -10 ? data.message : message,
                    title: status === -10 ? data.title : null,
                    data,
                    callback: () => {
                        Reoverlay.showModal(ErrorModal, {
                            title: 'خطا',
                            message: message || 'خطای سرویس',
                            showConfirmButton: false,
                            showCancelButton: true,
                            cancelButtonText: 'تلاش مجدد',
                            cancelButtonTheme: 'red',
                            onCancel: () => {
                                handleInquiryProcess();
                            }
                        })
                    }
                })
            } else {
                if (data?.process && data?.process?.pid) {
                    setPid(data.process.pid);
                    if (data?.process?.status && data?.process.status === "rejected") {
                        handleCreateProcess();
                    } else {
                        handleGetProcess(data.process.pid)
                    }
                } else {
                    handleCreateProcess();
                }
            }
        }).catch((e) => {

        }).finally(() => {

        })
    }
    const handleGetProcess = (newPid) => {
        setIsLoading({
            showLoading: true,
            text: 'در حال دریافت اطلاعات'
        })

        Api.get(REQUEST_URLS.DIVAR_FOREIGNER_AUTH.FETCH_PROCESS, {
            params: {
                pid: newPid,
            },
            headers: {
                "Authorization": `Bearer ${token}`
            }
        }).then(response => {
            const {data, status, message, hasError} = response;
            if (hasError) {

                handleError({
                    status,
                    message: status === -10 || status === -12 ? data.message : message,
                    title: status === -10 || status === -12 ? data.title : null,
                    data,
                    callback: () => {
                        Reoverlay.showModal(ErrorModal, {
                            title: 'خطا',
                            message: message || 'خطای دسترسی',
                            showConfirmButton: false,
                            showCancelButton: true,
                            cancelButtonText: 'تلاش مجدد',
                            cancelButtonTheme: 'red',
                            onConfirm: () => {
                                Reoverlay.hideModal();
                            },
                            onCancel: () => {
                                handleGetProcess(newPid);
                            }
                        })
                    }
                })
            } else {
                setComponents(data.components)
                setProcess(data.process);
                setIsLoading({
                    showLoading: false,
                    text: 'در حال دریافت اطلاعات'
                })

            }
        }).catch(e => {

        }).finally(() => {

        })
    }
    const handleError = ({onConfirm, onClose, message, title, pid, data, status, options, callback}) => {
        if (status === -12) {
            setIsLoading({
                showLoading: false,
                text: ''
            })
            setReported(true)
            setReportedMessage(message)
            setReportedTitle(title)

        } else if (status === -10) {
            setIsLoading({
                showLoading: false,
                text: ''
            });
            setIsFinal(true)
        } else if (status === 500) {
            Reoverlay.showModal(ErrorModal, {
                title: 'خطا',
                message: message || 'خطای سرویس',
                onConfirm: () => {
                    Reoverlay.hideModal();
                },
                showConfirmButton: false,
                showCancelButton: true,
                cancelButtonText: 'بستن',
                cancelButtonTheme: 'red',

                onCancel: () => {


                }
            })

        } else if (status === 403 || status === 401) {
            Reoverlay.showModal(ErrorModal, {
                title: 'خطا',
                message: message || 'خطای دسترسی',
                onConfirm: () => {
                    Reoverlay.hideModal();
                },
                showConfirmButton: false,
                showCancelButton: true,
                cancelButtonText: 'بازگشت به دیوار',
                cancelButtonTheme: 'red',

                onCancel: () => {
                    handleRedirectToDivar({})

                }
            })
        } else if (status === 801 || status === 802 || status === 803 || status === 805) {
            Reoverlay.showModal(ErrorModal, {
                title: 'خطا',
                message: message || 'خطای دسترسی',
                onConfirm: () => {
                    Reoverlay.hideModal();
                },
                showConfirmButton: false,
                showCancelButton: true,
                cancelButtonText: 'ساخت پروسه جدید',
                cancelButtonTheme: 'red',
                onCancel: () => {
                    handleCreateProcess();
                }
            })
        } else {
            callback()
        }
    }
    const handleComponents = (newComponents) => {
        setComponents(newComponents)
    }


    return <div>
        <ForeignerAuthenticationContext.Provider value={
            {
                isLoading,
                pid,
                token,
                process,
                components,
                handleLoading,
                handleUpdateStep,
                handleProcess,
                handleError,
                handleComponents,
                handleGetProcess,
                handleCreateProcess,
                handleRedirectToDivar,
            }
        }>

            {reported && <UserReportedCard title={reportedTitle} reportedMessage={reportedMessage}/>}
            {isLoading && isLoading.showLoading && <LoadingScreen text={isLoading.text}/>}
            {!reported && isFinal && <Final/>}
            {!reported && !isFinal && <>
                <StreamManager>
                    {process && components?.current_component?.name === ForeignerAuthenticationDefaultSteps.UNIQUE_FACE &&
                        <VideoValidation/>}
                    {process && components?.current_component?.name === ForeignerAuthenticationDefaultSteps.FOREIGNER_DOCUMENT_READER &&
                        <CardReader/>}
                </StreamManager>
                {(process && components?.current_component?.name === ForeignerAuthenticationDefaultSteps.FINAL) &&
                    <Final/>}
            </>}
        </ForeignerAuthenticationContext.Provider>
    </div>
}
export default ForeignerAuth;